//Billingpagecard
import React, { useState } from "react";
import "./billingcss.css";
import { useNavigate } from "react-router-dom";
import razorpayLogo from '../../../assets/images/razorpay.png';
import paypalLogo from '../../../assets/images/paypal.png';
import gpayLogo from '../../../assets/images/gpay.png';
import countryPhoneCodes from "../../../utility/Countrycodes";

function Paymentpagecard() {
  const navigate = useNavigate();
  var selectedPoem = JSON.parse(localStorage.getItem("selectedPoem")) || {};
  const isFund = selectedPoem.type === "fund";

  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCode, setSelectedCode] = useState("");
  const [selectedPayment, setSelectedPayment] = useState("");
  const [formInput, setFormInput] = useState({
    name: '',
    country: '',
    phoneNumber: '',
    email: '',
    address: '',
    pincode: '',
    quantity: '',
  });
  const [errors, setErrors] = useState({});

  //Phone number withcodes

  const countries = Object.keys(countryPhoneCodes);
  const phoneCodes = [...new Set(Object.values(countryPhoneCodes))];

  const handleCountryChange = (e) => {
    const selected = e.target.value;
    setSelectedCountry(selected);
    setSelectedCode(countryPhoneCodes[selected]);
  };

  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };

  //Validate individual field
  const validateField = (name, value) => {
    let error = '';
    if (name === 'name') {
      if (!value) error = 'Name is required';
      else if (value.length > 50) error = 'Name must be less than 50 characters';
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
    return error;
  };

  //Validate full form
  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formInput.name) newErrors.name = 'Name is required';
    else if (formInput.name.length > 20)
      newErrors.name = 'Name must be less than 20 characters';
    if (!selectedCountry) newErrors.country = 'Country is required';
    if (!selectedCode) newErrors.code = 'Phone code is required';
    if (!formInput.phoneNumber) {
      newErrors.phoneNumber = 'Phone number is required';
    } else if (!/^\d{10}$/.test(formInput.phoneNumber)) {
      newErrors.phoneNumber = 'Phone number must be exactly 10 digits';
    }
    if (!formInput.email) newErrors.email = 'Email is required';
    else if (!emailRegex.test(formInput.email)) newErrors.email = 'Invalid email format';
    if (!formInput.address) newErrors.address = 'Address is required';
    if (!formInput.pincode) newErrors.pincode = 'Pincode is required';
    if (!isFund && !formInput.quantity) newErrors.quantity = 'Quantity is required';
    if (isFund && !formInput.price) newErrors.price = 'Price is required';
    if (!selectedPayment) newErrors.payment = 'Payment method is required';

    setErrors(newErrors);
    console.log("validateeeee", newErrors)
    return Object.keys(newErrors).length === 0;
  };

  //Input handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prev) => ({
      ...prev,
      [name]: value
    }));
    validateField(name, value);
  };

  //handle payememt
  const handlePaymentChange = (event) => {
    setSelectedPayment(event.target.value);
  };

  //Handle navigation
  const handleClick = (e) => {
    e.preventDefault();
    const isValid = validateForm();
    console.log(isValid)
    if (isValid) {
      const billingData = {
        ...formInput,
        country: selectedCountry,
        code: selectedCode,
        paymentMethod: selectedPayment,
        type: selectedPoem.type
      };
      if (isFund) {
        selectedPoem.price = formInput.price;
        localStorage.setItem('selectedPoem', JSON.stringify(  ));
      }

      localStorage.setItem('billingData', JSON.stringify(billingData));
      console.log("check price info ", localStorage)
      navigate(`/billingdetails`);
    }
  };


  return (
    <div className="payment-page">
      <h3>Billing Details</h3>

      <form className="payment-form">

        <div className="form-group">
          <label htmlFor="fullName">Full Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formInput.name}
            onChange={handleChange}
            required />
        </div>
        {errors.name && <span className="error-text">{errors.name}</span>}

        {/* Country Selection */}
        <div className="form-group">
          <label htmlFor="country">Country</label>
          <select
            id="country"
            name="country"
            required
            value={selectedCountry}
            onChange={handleCountryChange}
          >
            <option value="" disabled>
              Select a country
            </option>
            {countries.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>
        {errors.country && <span className="error-text">{errors.country}</span>}

        <div className="form-group">
          <label htmlFor="phoneNumber">Phone Number</label>
          <div style={{ display: "flex", alignItems: "center" }}>
            <select
              value={selectedCode}
              onChange={handleCodeChange}
              style={{ marginRight: "8px", padding: "9px", width: "120px" }} >
              <option value="" disabled>
                Select Code
              </option>
              {phoneCodes.map((code) => (
                <option key={code} value={code}>
                  {code}
                </option>
              ))}
            </select>
            <input
              type="number"
              id="phoneNumber"
              name="phoneNumber"
              value={formInput.phoneNumber}
              onChange={handleChange}
              maxLength={10}
              required
            />
          </div>
        </div>
        {errors.phoneNumber && <span className="error-text">{errors.phoneNumber}</span>}


        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formInput.email}
            onChange={handleChange}
            required />
        </div>
        {errors.email && <span className="error-text">{errors.email}</span>}

        <div className="form-group">
          <label htmlFor="address">Full Address</label>
          <textarea id="address"
            name="address"
            rows="3"
            value={formInput.address}
            onChange={handleChange}
            required></textarea>
        </div>
        {errors.address && <span className="error-text">{errors.address}</span>}

        <div className="form-group">
          <label htmlFor="pincode">Pincode</label>
          <input
            type="number"
            id="pincode"
            name="pincode"
            value={formInput.pincode}
            onChange={handleChange}
            required />
        </div>
        {errors.pincode && <span className="error-text">{errors.pincode}</span>}

        {/* Quantity or Price */}
        <div className="form-group">
          <label htmlFor="quantityOrPrice" className="form-label">
            {isFund ? "Fund Price" : "Quantity"}
          </label>

          {isFund ? (
            <input
              type="number"
              id="price"
              name="price"
              value={formInput.price}
              onChange={handleChange}
              placeholder="Enter amount"
              required
            />
          ) : (
            <select
              id="quantity"
              name="quantity"
              value={formInput.quantity}
              onChange={handleChange}
              required
            >
              <option value="">-- Select Quantity --</option>
              {[...Array(10)].map((_, i) => (
                <option key={i + 1} value={i + 1}>{i + 1}</option>
              ))}
            </select>
          )}

          {isFund && errors.price && (
            <div className="error-text">{errors.price}</div>
          )}
          {!isFund && errors.quantity && (
            <div className="error-text">{errors.quantity}</div>
          )}
        </div>



        {/* options for payment */}

        <h4 style={{ fontSize: '18px' }}>Select Payment Method</h4>
        <div style={{ display: "flex", gap: "20px", alignItems: "center", justifyContent: "center" }}>
          <label style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="radio"
              name="payment"
              value="razorpay"
              checked={selectedPayment === "razorpay"}
              onChange={handlePaymentChange}
            />
            <img
              src={razorpayLogo}
              alt="Razorpay"
              className="payment-method-img"
            />
          </label>

          <label style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="radio"
              name="payment"
              value="gpay"
              checked={selectedPayment === "gpay"}
              onChange={handlePaymentChange}
            />
            <img
              src={gpayLogo}
              alt="gpay"
              className="payment-method-img"
            />
          </label>

          <label style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="radio"
              name="payment"
              value="paypal"
              checked={selectedPayment === "paypal"}
              onChange={handlePaymentChange}
            />
            <img
              src={paypalLogo}
              alt="PayPal"
              className="payment-method-img"
            />
          </label>


        </div>
        {errors.payment && <span className="error-text">{errors.payment}</span>}


        <button onClick={handleClick} className="payment-submit-button">
          Save and Continue
        </button>
      </form>
    </div>
  );
}

export default Paymentpagecard;